/**
 * Created by andrey on 11.08.2025
 */

cc.FiniteTimeAction = function () {
    cc.Action.prototype.constructor.call(this);
    this._duration = 0;
};

cc.FiniteTimeAction.prototype = Object.assign(Object.create(cc.Action.prototype), {
    constructor: cc.FiniteTimeAction,

    getDuration: function () {
        return this._duration;
    },

    setDuration: function (duration) {
        this._duration = duration;
    }
});